module.exports = __webpack_public_path__ + "static/img/专题活动页设计-活动页延展设计.8d1de51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10002/专题活动页设计-活动页延展设计.png
// module id = MQbc
// module chunks = 1